// Resolve a `/set gain:<token>` argument to the audio key it tunes, or null if the token
// isn't a tunable sound. `token` may be a WEAPON name (mapped to that weapon's sfx key) or
// a raw audio key; `gainSounds` is the set of keys that actually exist. Pure — AudioService
// wraps this around the live audio node, but the resolution itself needs no audio context,
// so scripts/client-sim.js can check it directly.
export function resolveGainKey(token, weapons, gainSounds) {
    const key = weapons[token] ? weapons[token].sfx : token;
    return gainSounds.has(key) ? key : null;
}
